import { render, staticRenderFns } from "./DxTableData.vue?vue&type=template&id=79d579b7&scoped=true"
import script from "./DxTableData.vue?vue&type=script&lang=js"
export * from "./DxTableData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d579b7",
  null
  
)

export default component.exports